import { CalendarX, MessageCircle } from "lucide-react";

import { LogoMark } from "@/components/site/LogoMark";
import { WHATSAPP_LINK } from "@/components/site/WhatsAppBubble";

export function FullyBookedHold() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-ink px-4 py-16 text-ink-foreground">
      <div className="w-full max-w-xl text-center">
        <div className="mx-auto flex items-center justify-center gap-3">
          <LogoMark className="size-12" />
          <span className="text-left">
            <span className="block font-display text-lg font-bold leading-tight">
              Car Rental Bucharest
            </span>
            <span className="block text-[11px] uppercase tracking-[0.2em] text-ink-foreground/60">
              carentals.ro
            </span>
          </span>
        </div>

        <div className="mx-auto mt-10 grid size-16 place-items-center rounded-2xl bg-gold text-gold-foreground">
          <CalendarX className="size-8" />
        </div>

        <h1 className="mt-6 font-display text-3xl font-extrabold sm:text-4xl">
          We are currently fully booked
        </h1>
        <p className="mt-4 text-base leading-relaxed text-ink-foreground/75">
          We're sorry for the inconvenience — our entire fleet is reserved until{" "}
          <span className="font-semibold text-gold">31 December 2026</span>. Online booking is
          temporarily unavailable.
        </p>
        <p className="mt-3 text-sm leading-relaxed text-ink-foreground/60">
          Need a car urgently? Message us on WhatsApp and we'll let you know the moment a car
          becomes available.
        </p>

        <a
          href={WHATSAPP_LINK}
          target="_blank"
          rel="noreferrer"
          className="mt-8 inline-flex items-center justify-center gap-2 rounded-full bg-gold px-6 py-3 text-sm font-semibold text-gold-foreground transition-opacity hover:opacity-90"
        >
          <MessageCircle className="size-4" />
          Chat on WhatsApp
        </a>
      </div>
    </div>
  );
}
